module.exports = __webpack_public_path__ + "static/img/shield-1.87d8d7e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shield-1.svg
// module id = ebG7
// module chunks = 1